import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SquarePostLoadingEffectComponent } from './square-post-loading-effect.component';

@NgModule({
	declarations: [],
	imports: [SquarePostLoadingEffectComponent],
	exports: [SquarePostLoadingEffectComponent],
})
export class SquarePostLoadingEffectModule {}
